import type { MutableRefObject } from 'react';
import { useCallback, useEffect, useState } from 'react';

import { checkOverflow } from '@jane/kiosk/util';

export const useIsOverflowing = (
  divRef: MutableRefObject<HTMLDivElement | null>
): boolean => {
  const [overflowActive, setOverflowActive] = useState<boolean>(false);

  const determineOverflow = useCallback(() => {
    setOverflowActive(checkOverflow(divRef.current));
  }, [divRef]);

  useEffect(() => {
    determineOverflow();

    window.addEventListener('resize', determineOverflow);
    return () => {
      window.removeEventListener('resize', determineOverflow);
    };
  }, [determineOverflow]);

  return overflowActive;
};
